var r="rgba(75, 194, 202, 1)";export{r as DEFAULT_COLOR_STRING};
//# sourceMappingURL=ColorPicker.constants.js.map
